// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__flexIt___mB3vR {
  display: flex;
  align-items: center;
}
.styles__input___ePCDw input {
  border: none;
  box-shadow: none;
  border-bottom: 1px solid #ccc;
  margin-top: 20px;
  margin: 0px;
  background: transparent;
}
.styles__count___SHWFK {
  margin-bottom: 0px !important;
  width: 80px;
  padding: 2px 5px;
  font-size: 14px;
}
.styles__textMuted___RuK23 {
  color: #7F7F7F;
  margin-right: 10px;
}
.styles__flexRowCenter___fGVuH {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.styles__cartItem___QL1lo {
  position: relative;
  overflow: hidden;
  justify-content: space-between;
}
.styles__productCol___JNkj6 {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eee;
}
.styles__leftAlign___FOLo6 {
  align-items: flex-start;
}
.styles__deleteButtonCol___K7E0e {
  margin-left: 5px;
  cursor: pointer;
}
@media (max-width: 991px) {
  .styles__deleteButtonCol___K7E0e {
    margin-left: 0;
    flex-direction: row;
  }
}
.styles__deleteButtonLabel___pErp1 {
  margin-left: 5px;
}
@media (min-width: 991px) {
  .styles__deleteButtonLabel___pErp1 {
    display: none;
  }
}
.styles__productRow___N8grc {
  display: flex;
  margin-bottom: 5px;
  flex-direction: row;
}
@media (max-width: 991px) {
  .styles__productRow___N8grc {
    flex-direction: column;
  }
}
.styles__productDescription___shMzQ {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.styles__productDescription___shMzQ .product-info-popover {
  width: 100%;
}
.styles__cartItemLink___g_jA1 {
  justify-content: space-between;
  padding: 5px 0;
  overflow: hidden;
  text-decoration: none !important;
  color: #333333 !important;
  width: 100%;
}
.styles__cartItemImg___HWVQt {
  height: 36px;
  width: 36px;
  float: left;
  margin-right: 10px;
}
.styles__cartItemStrong___ntgXQ {
  overflow: hidden;
  display: block;
}
.styles__cartItemRemove___rTBPs {
  text-align: right;
  color: #d8d8d8;
  background: transparent;
}
.styles__autoProductSuffix___dhGMm,
.styles__cartItemSummary____huMg {
  color: #888;
  font-size: 12px;
  display: block;
}
.styles__productUnit___DPctK {
  margin: 4px 0 0 8px;
}
.styles__productTitle___sjp0K {
  font-weight: 400;
  font-size: 18px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 34px);
  white-space: nowrap;
}
.styles__productTitleLinked___5c_LY {
  text-decoration: underline;
}
.styles__priceColumn___Bokxs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}
.styles__price___B8Wos {
  font-size: 24px;
}
.styles__delete___GxaK9 {
  color: #0988cd;
}
.styles__flexSpaceBetween___KpvO1 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/CheckoutComponent/ProductItem/styles.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;AADF;AAIA;EAEI,YAAA;EACA,gBAAA;EACA,6BAAA;EAEA,gBAAA;EACA,WAAA;EACA,uBAAA;AAJJ;AAOA;EACE,6BAAA;EAEA,WAAA;EACA,gBAAA;EACA,eAAA;AALF;AAQA;EACE,cAAA;EACA,kBAAA;AANF;AASA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAPF;AAUA;EAEE,kBAAA;EACA,gBAAA;EACA,8BAAA;AARF;AAWA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AATF;AAYA;EACE,uBAAA;AAVF;AAaA;EAEE,gBAAA;EAKA,eAAA;AAfF;AAWE;EAAA;IACE,cAAA;IACA,mBAAA;EARF;AACF;AAYA;EACE,gBAAA;AAVF;AAWE;EAAA;IACE,aAAA;EARF;AACF;AAUA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AARF;AAYE;EAAA;IACE,sBAAA;EATF;AACF;AAYA;EAEE,sBAAA;EACA,uBAAA;EACA,WAAA;AAVF;AAMA;EAOI,WAAA;AAVJ;AAcA;EAEE,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;AAZF;AAeA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAbF;AAgBA;EACE,gBAAA;EACA,cAAA;AAdF;AAiBA;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;AAfF;AAkBA;;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAfF;AAkBA;EACE,mBAAA;AAhBF;AAmBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;AAjBF;AAoBA;EACE,0BAAA;AAlBF;AAqBA;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAnBF;AAsBA;EACE,eAAA;AApBF;AAuBA;EACE,cAAA;AArBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AAtBF","sourcesContent":["@import '../../../../shared/variables.less';\n\n.flexIt {\n  display: flex;\n  align-items: center;\n}\n\n.input {\n  input {\n    border: none;\n    box-shadow: none;\n    border-bottom: 1px solid #ccc;\n    // margin-bottom: 40px;\n    margin-top: 20px;\n    margin: 0px;\n    background: transparent;\n  }\n}\n.count {\n  margin-bottom: 0px !important;\n  composes: input;\n  width: 80px;\n  padding: 2px 5px;\n  font-size: 14px;\n}\n\n.textMuted {\n  color: @eon-text-color-muted;\n  margin-right: 10px;\n}\n\n.flexRowCenter {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n.cartItem {\n  composes: flexIt;\n  position: relative;\n  overflow: hidden;\n  justify-content: space-between;\n}\n\n.productCol {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #eee;\n}\n\n.leftAlign {\n  align-items: flex-start;\n}\n\n.deleteButtonCol {\n  composes: productCol;\n  margin-left: 5px;\n  @media (max-width: 991px) {\n    margin-left: 0;\n    flex-direction: row;\n  }\n  cursor: pointer;\n}\n\n.deleteButtonLabel {\n  margin-left: 5px;\n  @media (min-width: 991px) {\n    display: none;\n  }\n}\n.productRow {\n  display: flex;\n  margin-bottom: 5px;\n  flex-direction: row;\n  // @media (min-width: 991px) {\n  //   height: 118px;\n  // }\n  @media (max-width: 991px) {\n    flex-direction: column;\n  }\n}\n\n.productDescription {\n  composes: flexIt;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n\n  :global(.product-info-popover) {\n    width: 100%;\n  }\n}\n\n.cartItemLink {\n  composes: flexIt;\n  justify-content: space-between;\n  padding: 5px 0;\n  overflow: hidden;\n  text-decoration: none !important;\n  color: @eon-text-color-light !important;\n  width: 100%;\n}\n\n.cartItemImg {\n  height: 36px;\n  width: 36px;\n  float: left;\n  margin-right: 10px;\n}\n\n.cartItemStrong {\n  overflow: hidden;\n  display: block;\n}\n\n.cartItemRemove {\n  text-align: right;\n  color: @eon-border-color;\n  background: transparent;\n}\n\n.autoProductSuffix, .cartItemSummary {\n  color: #888;\n  font-size: 12px;\n  display: block;\n}\n\n.productUnit {\n  margin: 4px 0 0 8px;\n}\n\n.productTitle {\n  font-weight: 400;\n  font-size: 18px;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(100% - 34px);\n  white-space: nowrap;\n}\n\n.productTitleLinked {\n  text-decoration: underline;\n}\n\n.priceColumn {\n  composes: productCol;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.price {\n  font-size: 24px;\n}\n\n.delete {\n  color :#0988cd\n}\n\n.flexSpaceBetween {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexIt": `styles__flexIt___mB3vR`,
	"input": `styles__input___ePCDw`,
	"count": `styles__count___SHWFK styles__input___ePCDw`,
	"textMuted": `styles__textMuted___RuK23`,
	"flexRowCenter": `styles__flexRowCenter___fGVuH`,
	"cartItem": `styles__cartItem___QL1lo styles__flexIt___mB3vR`,
	"productCol": `styles__productCol___JNkj6`,
	"leftAlign": `styles__leftAlign___FOLo6`,
	"deleteButtonCol": `styles__deleteButtonCol___K7E0e styles__productCol___JNkj6`,
	"deleteButtonLabel": `styles__deleteButtonLabel___pErp1`,
	"productRow": `styles__productRow___N8grc`,
	"productDescription": `styles__productDescription___shMzQ styles__flexIt___mB3vR`,
	"cartItemLink": `styles__cartItemLink___g_jA1 styles__flexIt___mB3vR`,
	"cartItemImg": `styles__cartItemImg___HWVQt`,
	"cartItemStrong": `styles__cartItemStrong___ntgXQ`,
	"cartItemRemove": `styles__cartItemRemove___rTBPs`,
	"autoProductSuffix": `styles__autoProductSuffix___dhGMm`,
	"cartItemSummary": `styles__cartItemSummary____huMg`,
	"productUnit": `styles__productUnit___DPctK`,
	"productTitle": `styles__productTitle___sjp0K`,
	"productTitleLinked": `styles__productTitleLinked___5c_LY`,
	"priceColumn": `styles__priceColumn___Bokxs styles__productCol___JNkj6`,
	"price": `styles__price___B8Wos`,
	"delete": `styles__delete___GxaK9`,
	"flexSpaceBetween": `styles__flexSpaceBetween___KpvO1`
};
export default ___CSS_LOADER_EXPORT___;
